<template>
  <div>
    <base-editor-quill class="mt-5" v-model="new_value" outlined dense single-line rows="15"/>
    <v-btn text block color="primary" @click="$refs.modal_message.open();this.getMessageTemplates();">
      {{ $store.getters.translate("choose_from_message_templates") }}
    </v-btn>
    <BaseDraggableModal
        :name="'modal_message'"
        max-height="80vh"
        width="70vw"
        :fullscreen="$vuetify.breakpoint.xsOnly"
        ref="modal_message">
      <v-card :loading="loading">
        <BaseModal>
          <v-toolbar slot="header" class="draggable_selector" dark color="primary" dense flat>
            <v-toolbar-title>{{ $store.getters.translate("messagetemplates") }} {{ $store.getters.translate(module_name) }}</v-toolbar-title>
            <v-spacer/>
            <v-btn text small @click.stop="$refs.modal_message.close()">
              <v-icon>mdi-content-save</v-icon>
            </v-btn>
          </v-toolbar>
          <div slot="content">
            <v-divider/>
            <v-card-text v-if="!show_create">
              <v-data-table
                :headers="headers"
                :items="messagetemplates"
                :loading="loading"
                selectable-key="id"
                hide-default-footer>
                <template v-slot:item.name="{ item }">
                  <a @click="setMessage(item.message)" v-html="item.message"></a>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-icon small @click="deleteRecord(item.id)">mdi-delete</v-icon>
                </template>
              </v-data-table>
            </v-card-text>
          </div>
        </BaseModal>
      </v-card>
    </BaseDraggableModal>
  </div>
</template>

<script>
import BaseModal from "./BaseModal";
import BaseDraggableModal from "./BaseDraggableModal";
import BaseEditorQuill from "./BaseEditorQuill";

export default {
  components: {
    BaseModal,
    BaseDraggableModal,
    BaseEditorQuill,
  },
  props: ["value", "module_name", "single"],
  data() {
    return {
      new_value: [],
      messagetemplates: [],
      loading: false,
      show_create: false,
      record: {
        name: "",
        message: "",
      },
      headers: [
        {
          text: this.$store.getters.translate("name"),
          align: "start",
          sortable: true,
          value: "name",
        },
        {
          text: this.$store.getters.translate("actions"),
          sortable: false,
          align: "right",
          value: "actions",
        },
      ],
    };
  },
  created() {
    this.new_value = this.value;
    this.getMessageTemplates();
  },
  methods: {
    update() {
      this.$emit("input", this.new_value);
      this.$emit("change");
    },
    async getMessageTemplates() {
      this.loading = true;
      this.$http
        .get(this.$store.getters.appUrl + "v2/messagetemplates")
        .then((response) => {
          this.messagetemplates = response.data;
          this.$emit("messagetemplates", this.messagetemplates);
          this.loading = false;
        })
        .catch((error) => {
          if (this.$store.getters.isLoggedIn) {
            this.$toasted.error(error);
          }
          this.loading = false;
        });
    },
    deleteRecord(id) {
      this.loading = true;
      this.$http
        .delete(this.$store.getters.appUrl + "v2/messagetemplates/" + id)
        .then(() => {
          this.getMessageTemplates();
          this.loading = false;
        })
        .catch((error) => {
          if (this.$store.getters.isLoggedIn) {
            this.$toasted.error(error);
          }
          this.loading = false;
        });
    },
    setMessage(message) {
      this.$refs.modal_message.close();
      this.getMessageTemplates();
      this.new_value = message;
    },
  },
  watch: {
    new_value: {
      handler() {
        this.update();
      },
    },
    value: {
      handler() {
        this.new_value = this.value;
      },
    },
  },
};
</script>